module.exports = __webpack_public_path__ + "img/pierre_s.4b1783e7.png";